import { ICurrentLang } from './type';

const useLanguage = (
  tenantSiteLanguages: string[] = []
): { LANGS: ICurrentLang[] } => {
  // Ensure we have at least English as a default language if no languages are provided
  const languagesToUse =
    tenantSiteLanguages && tenantSiteLanguages.length > 0
      ? tenantSiteLanguages
      : ['en'];

  const LANGS: ICurrentLang[] = languagesToUse.map((lang) => ({
    value: lang,
    label: lang.toUpperCase(),
    icon1: `${lang}.svg`
  }));

  return { LANGS };
};

export default useLanguage;
